import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';
import { getProductCardIconWithTooltip } from '../../utils/productCardUtils';
import { sortInteriors } from 'rangeConfig/kallax/sorting/sort';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseInsertsAndBoxes',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: [
    {
      cardsTitle: 'name',
      id: 'interior-selected-menu-interior',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      filters: [],
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productTypes: [
        ProductType.KALLAX_BASKETS,
        ProductType.KALLAX_BOXES,
        ProductType.KALLAX_CABINETS,
        ProductType.KALLAX_DIVIDERS,
        ProductType.KALLAX_DRAWERS
      ],
      productFilters: [],
      cluster: ['globalItemNo'],
      sortClusteredProducts: sortInteriors,
      productCardIcon: getProductCardIconWithTooltip
    }
  ]
};

export default selectedMenu;
